import { FC, useEffect } from 'react'

import { AddChangeLogEntryForm } from '../../../containers'
import { AddChangeLogEntryFormData } from '../../../entities/ChangeLog/ChangeLog'
import trans from '../../../helpers/trans'
import { addChangeLogEntry } from '../../../redux/changeLogEntry/changeLogEntryActions'
import { setIsSuccessful } from '../../../redux/changeLogEntry/changeLogEntryReducer'
import { useTypedDispatch, useTypedSelector } from '../../../redux/store'
import { setToast } from '../../../redux/toasts/toastsReducer'
import { ToastType } from '../../../types'

interface ConnectedAddChangeLogEntryFormProps {
    onClose: () => void
}

export const ConnectedAddChangeLogEntryForm: FC<ConnectedAddChangeLogEntryFormProps> = ({
    onClose,
}) => {
    const dispatch = useTypedDispatch()
    const { isLoading, isSuccessful } = useTypedSelector(state => state.changeLogEntryReducer)

    const handleAddChangeLogEntry = (addChangeLogEntryFormData: AddChangeLogEntryFormData): void => {
        dispatch(addChangeLogEntry(addChangeLogEntryFormData))
    }

    useEffect(() => {
        if (isSuccessful) {
            dispatch(setIsSuccessful(false))

            dispatch(setToast({
                text: trans('containers.forms.addChangeLogEntryForm.addChangeLogEntrySuccess'),
                type: ToastType.pass,
            }))

            onClose()
        }
    }, [isSuccessful])

    return (
        <AddChangeLogEntryForm
            isLoading={isLoading}
            onSubmit={handleAddChangeLogEntry}
            onCancel={onClose}
        />
    )
}
